import React from 'react'
//import {Link} from 'gatsby'
//import rawEmojis from '../../static/emojis/emojis.js'
import asthalogo from "../images/asthait.jpg"
import kdslogo from "../images/kds.png"
import automatelogo from '../images/automate.png'
import * as workStyle from './componentStyles/work.module.scss'
const WorkExp = () => {
    return (
            <div className={workStyle.content}>
            <h3 style={{textDecoration:"underline", textDecorationStyle:"double", fontWeight:"bold" }}>Work</h3>
            
            <div style={{display:'flex', flexDirection:'column'}} >
                        
                        <div style={{display:"flex", flexDirection:'column', justifyContent:'center', alignItems:'center'}} id={'#comInfo'}>
                            <div style={{fontWeight:'bold', fontSize:20}}>Sr.  Software Engineer</div>
                            <div style={{fontStyle:'italic', fontSize:15}}>Jan 2022 ~ Present</div>
                            <img width={50} height={50} style={{marginBottom:2, marginTop:2}} alt='astha' src={asthalogo}/>
                            <div>Astha IT</div>
                            <div style={{fontWeight:'initial'}}>Core Engineering Team</div>
                        </div>
                        
                        <div className={workStyle.horizontalLine}/>
                    
                        <div style={{display:"flex", flexDirection:'column', justifyContent:'center', alignItems:'center'}} id={'#comInfo'}>
                            <div style={{fontWeight:'bold', fontSize:20}}>Software Engineer</div>
                            <div style={{fontStyle:'italic', fontSize:15}}>Jan 2018 ~ Jan 2022</div>
                            <img width={50} height={50} style={{marginBottom:2, marginTop:2}} alt='kds' src={kdslogo}/>
                            <div>KDS Group</div>
                            <div style={{fontWeight:'initial'}}>KDS Automation & Systems</div>
                            {/* <span>
                              <p>
                                <a className={workStyle.moreLink} rel="noopener noreferrer" href="https://www.linkedin.com/in/absjabed/" target="_blank">more info...</a>
                              </p>
                            </span>                             */}
                        </div>
                        
                        <div className={workStyle.horizontalLine}/>

                        <div style={{display:"flex", flexDirection:'column', justifyContent:'center', alignItems:'center'}} id={'#comInfo'}>
                            <div style={{fontWeight:'bold', fontSize:20}}>Mobile Application Developer</div>
                            <div style={{fontStyle:'italic', fontSize:15}}>Aug 2016 ~ Oct 2017</div>
                            <img width={130} height={60} style={{marginBottom:2, marginTop:2}} alt='automate' src={automatelogo}/>
                            <div style={{fontWeight:'initial'}}>Automate Infosys Limited</div>
                            <div>Chittagong</div>
                            {/* <span>
                            <p>
                                <a className={workStyle.moreLink} rel="noopener noreferrer" href="https://www.linkedin.com/in/absjabed/" target="_blank">more info...</a>
                            </p>
                            </span> */}
                            
                        </div>
                        <div className={workStyle.horizontalLine}/>
            </div>
        </div>
    )
}

export default WorkExp;
